export type DataSourceSignals = { hasPitchDeck: boolean; hasDataRoom: boolean; hasScoreEvent: boolean };

export type CompletionInput = {
  hasActiveMembership: boolean;
  isInvitee: boolean;
  personalProfileDone: boolean;
  dataSource: DataSourceSignals;
};

export function hasDataSource(s: DataSourceSignals): boolean {
  return s.hasPitchDeck || s.hasDataRoom || s.hasScoreEvent;
}

export function computeOnboardingComplete(input: CompletionInput): boolean {
  if (!input.hasActiveMembership || !input.personalProfileDone) return false;
  if (input.isInvitee) return true;
  return hasDataSource(input.dataSource);
}
